export const RETURN_LINK = '/return';
export const OUIGO = 'ouigo';
export const OUTBOUND = 'outboundTrip';
export const RETURN = 'returnTrip';
